import React, { useState, useEffect } from 'react'
import { RecurringJobsSettingInputType } from '.'
import { CircularAvatar } from '../../commons';
import ReactDatePicker from 'react-datepicker';
import { Col, Label, Row } from 'reactstrap';
import moment from 'moment';
import { CalenderIcon } from '../../Icon';
import { RedDeleteIcon } from '../../../assets/images';
import Select from 'react-select';
import { components } from 'react-select';
import { DropDownType } from '../../../commonTypes/clientDirectoryTypes';
import { formatDate } from '../../../utils/commonFunctions';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

type AppProps = {
    recurringJobsSettingInputData: RecurringJobsSettingInputType[];
    handleRemoveRow: (index: number) => void;
    handleRecurringInputDetailsChange: (dataKey: any,
        value: any,
        index: number) => void;
    setoffset: React.Dispatch<React.SetStateAction<number>>;
    setText: React.Dispatch<React.SetStateAction<string>>;
    userFetching: boolean;
    fetching: boolean;
    limit: number;
    text: string;
    singleJobsType: any;
    setManagerOffset: React.Dispatch<React.SetStateAction<number>>;
    setJobTypeOffset: React.Dispatch<React.SetStateAction<number>>;
    setManagerText: React.Dispatch<React.SetStateAction<string>>;
    setJobTypeText: React.Dispatch<React.SetStateAction<string>>;
    managerFetching: boolean;
    managerLimit: number;
    jobTypeLimit: number;
    finalUserList: DropDownType[];
    finalManagerList: DropDownType[];
    finalJobTypeList: DropDownType[];
    officerFetching: boolean;
    setGovtOffset: React.Dispatch<React.SetStateAction<number>>;
    setGovtText: React.Dispatch<React.SetStateAction<string>>;
    finalGovtOfficerList: any;
    govtLimit: number;
}
const RecurringJobsSettingInput = ({
    recurringJobsSettingInputData,
    handleRemoveRow,
    finalUserList,
    finalManagerList,
    setoffset,
    managerLimit,
    jobTypeLimit,
    setManagerText,
    setManagerOffset,
    setJobTypeOffset,
    limit,
    setText,
    setJobTypeText,
    text,
    userFetching,
    managerFetching,
    finalJobTypeList,
    fetching,
    handleRecurringInputDetailsChange,
    singleJobsType,
    setGovtText,
    finalGovtOfficerList,
    officerFetching,
    setGovtOffset,
    govtLimit,
}: AppProps) => {
    const [index, setIndex] = useState<any>(null)
    const [item, setItem] = useState({})
    const [data, setData] = useState<any>(JSON.parse(JSON.stringify(recurringJobsSettingInputData)))
    const [finalJobTypeListData, setFinalJobTypeListData] = useState<any>([])

  useEffect(() => {
        if (finalJobTypeListData?.length <=5&&finalJobTypeListData?.length!==0) {
            checkJobTypeBottom()
        }
    }, [finalJobTypeListData])

    useEffect(() => {
        let arr: any[] = []
        recurringJobsSettingInputData?.map((item: any) => {
            arr.push({ ...item })
        })
        setData([...arr])
    }, [recurringJobsSettingInputData])

    useEffect(() => {
        if (index != null) {
            fillJobDetails(item, index)
        }
    }, [singleJobsType])

    useEffect(() => {
        let id = data?.map((el: any) => {
            return el?.jobType?.value
        })
        if (!!id[0]?.length) {
            let filterData = finalJobTypeList?.filter((item: any) => {
                return !id?.includes(item?.value)
            })
            setFinalJobTypeListData([...filterData])
        }
        else{
            setFinalJobTypeListData([...finalJobTypeList])
        }
    }, [finalJobTypeList, data])

    const fillJobDetails = (item: any, i: number) => {
        if (i === index && singleJobsType) {
            item["description"] = singleJobsType?.job_details
            item["nextJobDate"] = singleJobsType?.recurring_job_settings?.next_job_start_date
            item["jobType"].label = singleJobsType?.job_type
            item["jobType"].value = singleJobsType?._id
            item["jobTypeError"] = ""
            item["manager"]={
               value:null,
               label: "Select.."
            }
            item["responsible"]={
               value:null,
               label: "Select.."
            }
            item["govtOfficer"]={
                value:null,
                label: "Select.."
            }
        }
        recurringJobsSettingInputData[index] = { ...item }
        setData([...recurringJobsSettingInputData])
    }

    const checkBottom = () => {
        setoffset((prv: any) => prv + limit);
    };

    
    const checkManagerBottom = () => {
        setManagerOffset((prv: any) => prv + managerLimit);
    };

    const checkJobTypeBottom = () => {
        setJobTypeOffset((prv: any) => prv + jobTypeLimit);
    };

    const checkGovtBottom = () => {
        setGovtOffset((prv: any) => prv + govtLimit);
    };

    const Option = (props: any) => {
        const { data } = props;
        return (
            <components.Option {...props} >
                <div className='d-flex justify-content-sm-start' style={{ gap: '10px' }}>
                    <CircularAvatar name={data?.label.split("%")[0]} image={data?.image && data?.image} />
                    <div style={{ marginTop: "-3px" }}>
                        <span style={{ fontWeight: "500", fontSize: "16px" }}>{data?.label.split("%")[0]}</span>
                        <br></br>
                        <span style={{ color: "#6e7491" }}>{data?.label.split("%")[1]}</span>
                    </div>
                </div>
            </components.Option>
        );
    };

    const dropDownStyle = {
        option: (baseStyles: any, state: any) => ({
            ...baseStyles,
            width: '100%',
        }),
        control: (provided: any, state: any) => ({
            ...provided,
            width: '150px',
        }),
        container: (provided: any) => ({
            ...provided,
            width: "150%",
            // position: 'absolute'
        })
    }

    const jobDropDownStyle = {
        option: (baseStyles: any, state: any) => ({
            ...baseStyles,
            width: '100%',
        }),
        control: (provided: any, state: any) => ({
            ...provided,
            width: '280px',
        }),
        container: (provided: any) => ({
            ...provided,
            width: "150%",
            // position: 'absolute'
        })
    }

    const renderRecurringJobsSettingInput = () => {
        let arr: any[] = [];
        data?.map((item: any, i: number) => {

            if (item?.hasOwnProperty("jobType")) {
                arr.push(
                    <tr style={{ borderLeft: "none", borderRight: "none" }}>
                        {/* <div className='row'> */}
                        <td className='pr-0 pl-1' style={{ borderLeft: "none", borderRight: "none" }}>
                            <div style={{ position: "relative" }}>
                                {/* <label style={{fontSize:"12px"}}>Job Type<span style={{ color: "red" }}>*</span></label> */}
                                <Select
                                    // className={`${item?.jobTypeError?"error-border rounded":""}`}
                                    styles={jobDropDownStyle}
                                    options={finalJobTypeListData}
                                    value={item?.jobType}
                                    onChange={(e) => handleRecurringInputDetailsChange("jobType", e, i)}
                                    isSearchable={true}
                                    isLoading={fetching}
                                    // onMenuClose={() => { setJobTypeOffset(0) }}
                                    onMenuScrollToBottom={checkJobTypeBottom}
                                    onInputChange={(e) => {
                                        setJobTypeText(e)
                                        setIndex(i)
                                        setItem(item)
                                    }}
                                />
                                {item?.jobTypeError &&
                                    (<span className='text-danger' style={{ position: "absolute", top: "40px", fontSize: "12px", left: "5px" }}>{item?.jobTypeError ? item?.jobTypeError : ""}</span>)
                                }
                            </div>

                        </td>
                        <td className='pr-1 pl-3' style={{wordBreak:"break-all"}}>
                            <span>{item?.description?.length > 35 ? <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 250 }}
                                overlay={
                                    <Tooltip id="button-view-filter-invoice">
                                        {item?.description}
                                    </Tooltip>
                                }
                            >
                                <p>{`${item?.description?.slice(0, 35)}...`}</p>
                            </OverlayTrigger> : item?.description ? item?.description : "--/--"
                            }</span>
                            {/* <div className='form-group'>
                                <input
                                    type="text"
                                    className='form-control'
                                    value={item?.description}
                                    onChange={(e) => handleRecurringInputDetailsChange("description", e.target.value, i)}
                                />
                            </div> */}
                        </td>
                        <td className='pl-1 pr-3'>
                            <span>{item?.nextJobDate ? formatDate(item?.nextJobDate) : "--/--"}</span>
                            {/* <div className='form-group'>
                                <input
                                    type="text"
                                    className='form-control'
                                    value={item?.nextJobDate}
                                    onChange={(e) => handleRecurringInputDetailsChange("nextJobDate", e.target.value, i)}
                                />
                            </div> */}
                        </td>
                        <td className='pl-0 pr-1' style={{maxWidth:"170px"}}>
                            <div style={{ position: "relative" }}>
                                {/* <label style={{fontSize:"12px"}}>Manager<span style={{ color: "red" }}>*</span></label> */}
                                <Select
                                    // className={`${item?.managerError?"error-border rounded":""}`}
                                    styles={dropDownStyle}
                                    options={finalManagerList}
                                    value={item?.manager}
                                    components={{ Option }}
                                    onChange={(e) => handleRecurringInputDetailsChange("manager", e, i)}
                                    isSearchable={true}
                                    isLoading={managerFetching}
                                    onMenuClose={() => { setManagerOffset(0) }}
                                    onMenuScrollToBottom={checkManagerBottom}
                                    onInputChange={(e) => {
                                        setManagerText(e)
                                    }}
                                />
                                {item?.managerError && (
                                    <small className='text-danger' style={{ position: "absolute", top: "40px", fontSize: "12px", left: "5px" }}>{item?.managerError ? item?.managerError : ""}</small>
                                )}
                            </div>
                        </td>
                        <td className='pl-0 pr-0' style={{maxWidth:"170px"}}>
                            <div style={{ position: "relative" }}>
                                {/* <label style={{fontSize:"12px"}}>Responsible<span style={{ color: "red" }}>*</span></label> */}
                                <Select
                                    // className={`${item?.responsibleError?"error-border rounded":""}`}
                                    styles={dropDownStyle}
                                    options={finalUserList}
                                    value={item?.responsible}
                                    components={{ Option }}
                                    onChange={(e) => handleRecurringInputDetailsChange("responsible", e, i)}
                                    isSearchable={true}
                                    isLoading={userFetching}
                                    onMenuClose={() => { setoffset(0) }}
                                    onMenuScrollToBottom={checkBottom}
                                    onInputChange={(e) => {
                                        setText(e)
                                    }}
                                />
                                {item?.responsibleError && (
                                    <small className='text-danger' style={{ position: "absolute", top: "40px", fontSize: "12px", left: "5px" }}>{item?.responsibleError ? item?.responsibleError : ""}</small>
                                )}
                            </div>
                        </td>
                        <td className='pl-0 pr-0' style={{maxWidth:"170px"}}>
                            <div style={{ position: "relative", marginLeft: "5px"}}>
                                {/* <label style={{fontSize:"12px"}}>Govt. Officer<span style={{ color: "red" }}>*</span></label> */}
                                <Select
                                    // className={`${item?.responsibleError?"error-border rounded":""}`}
                                    styles={dropDownStyle}
                                    options={finalGovtOfficerList}
                                    value={item?.govtOfficer}
                                    components={{ Option }}
                                    onChange={(e) => handleRecurringInputDetailsChange("govtOfficer", e, i)}
                                    isSearchable={true}
                                    isLoading={officerFetching}
                                    onMenuClose={() => { setGovtOffset(0) }}
                                    onMenuScrollToBottom={checkGovtBottom}
                                    onInputChange={(e) => {
                                        setGovtText(e)
                                    }}
                                />
                                {item?.govtOfficerError && (
                                    <small className='text-danger' style={{ position: "absolute", top: "40px", fontSize: "12px", left: "5px" }}>{item?.govtOfficerError ? item?.govtOfficerError : ""}</small>
                                )}
                            </div>
                        </td>
                        <td className='col-md-3 pl-3' >
                            <Row>
                                <Col className='pl-1 pr-1'>
                                    <div className="form-group">
                                        <div className='date-picker-wraper mr-0'>
                                            <Label className='m-0 p-0 w-100'>
                                                <ReactDatePicker
                                                    dateFormat="dd-MM-yyyy"
                                                    selected={item?.engagementCutoffDate ? new Date(moment(`${item?.engagementCutoffDate}T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                                                    onChange={(e: any) => { handleRecurringInputDetailsChange?.("engagementCutoffDate", moment(e).format('YYYY-MM-DD'), i) }}
                                                    fixedHeight
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    name='dateOfInvoice'
                                                    placeholderText='Choose Date'
                                                    className='form-control'
                                                />
                                                <span className="calender-icon" style={{ right: '20px', cursor: 'pointer', top: "7px" }}>
                                                    <CalenderIcon />
                                                </span>
                                            </Label>
                                        </div>
                                    </div>
                                </Col>
                                {recurringJobsSettingInputData?.length > 0 && <Col className='form-control d-flex align-items-sm-center mr-2 p-2' xs={1} style={{ minWidth: "39px" }}>
                                    <img className="pointer" onClick={() => handleRemoveRow(i)} style={{}} src={RedDeleteIcon} alt='delete' />
                                </Col>}
                            </Row>
                        </td>
                        {/* </div> */}
                    </tr>
                )
            }
            // if (item?.hasOwnProperty("narration")) {
            //     arr.push(
            //         <tr>{recurringJobsSettingInputData?.length > 1 ? (
            //             <td>
            //                 <img className="pointer" src={RedDeleteIcon} onClick={() => handleRemoveRow(i)} />
            //             </td>
            //         ) : null}
            //         </tr>
            //     )
            // }
        })
        return arr;
    }

    return (
        <>{renderRecurringJobsSettingInput()}</>
    )
}

export default RecurringJobsSettingInput